// extracted by mini-css-extract-plugin
module.exports = {"formContainer":"RegisteredUserProfile_formContainer__1gcAy","chickInfo":"RegisteredUserProfile_chickInfo__2o5PK"};